var map = {
	"./angpao.webp": 2301,
	"./bonus.webp": 2302,
	"./gpi-rebate-m.webp": 2303,
	"./gpi-rebate.webp": 2304,
	"./hublot-watch-2018.webp": 2305,
	"./hublot-watch-2022.webp": 2306,
	"./iphone-13-pro-max.webp": 2307,
	"./iphone-14-pro-max.webp": 2308,
	"./login-to-m.webp": 2309,
	"./login-to.webp": 2310,
	"./mb.webp": 2311,
	"./mg-rebate-m.webp": 2312,
	"./mg-rebate.webp": 2313,
	"./np.webp": 2314,
	"./pointer.webp": 2315,
	"./pp-rebate-m.webp": 2316,
	"./pp-rebate.webp": 2317,
	"./sadface.webp": 2318,
	"./wallet-m.webp": 2319,
	"./wallet.webp": 2320,
	"./wheel-b.webp": 2321,
	"./wheel-btn.webp": 2322,
	"./wheel-indon-b.webp": 2323,
	"./wheel-indon.webp": 2324,
	"./wheel.webp": 2325
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 923;